import { OPEN_API } from './index';
const endpoints = {
    themes: '/themes',
    targetGroups: '/target-groups',
};
export const getRalliesThemes = async () => {
    return await OPEN_API.GET.all({
        endpoint: endpoints.themes,
    });
};
export const getRalliesTargetGroups = async () => {
    return await OPEN_API.GET.all({
        endpoint: endpoints.targetGroups,
    });
};
